// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"385de427","217":"94e4d578","282":"364ce160","777":"978fe4b0","875":"b37fad64"}[chunkId] + ".chunk.js";
};